import React, { useEffect, useState } from "react";
import { Card, Checkbox, Button, Select } from "antd";
import CoinImage from "../../assets/images/coin-image.svg";
import AuctionImage from "../../assets/images/auction-image.png";
import { useAuction } from "../../context/AuctionContext";
import { useGlobalSearch } from "../../context/GlobalSearchContext";

import Main from "../../components/layout/Main";
import { useNavigate } from "react-router";
import { Plus } from "lucide-react";
import {
  convertSecondToHours,
  DEFAULT_LIMIT,
  DEFAULT_PAGE,
  isScrollAtBottom,
} from "../../helper/functions";

const AuctionsPage = () => {
  const navigate = useNavigate();
  const { loadAuctions } = useAuction();
  const { globalSearch } = useGlobalSearch();

  const [activeMode, setActiveMode] = useState("All Auctions");
  const [auctions, setAuctions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [hasMore, setHasMore] = useState(true);

  const [params, setParams] = useState({
    page: DEFAULT_PAGE,
    limit: DEFAULT_LIMIT,
    filterType: null,
    status: undefined,
    search: undefined,
  });

  // ----------------- FILTER MAPPING -----------------
  const filterMapping = {
    "All Auctions": null,
    "High Bids": "highBids",
    "New Items": "newItems",
    "Ending Soon": "endingSoon",
  };

  // ----------------- FETCH FUNCTION -----------------
  const fetchAuctions = async (reset = false) => {
    try {
      setLoading(true);

      const response = await loadAuctions(params);

      if (response.success) {
        const items = response.data.items || [];

        if (reset) {
          setAuctions(items);
        } else {
          setAuctions((prev) => [...prev, ...items]);
        }

        // check whether more items exist
        setHasMore(items.length === params.limit);
      }
    } catch (err) {
      console.error("Fetch error:", err);
    } finally {
      setLoading(false);
    }
  };

  // ----------------- FILTER CHANGE -----------------
  const handleFilterChange = (mode) => {
    setActiveMode(mode);

    const filterType = filterMapping[mode];

    setParams((prev) => ({
      ...prev,
      page: 1,
      filterType: filterType,
      status: filterType ? "Open" : undefined,
    }));
  };

  // ----------------- SCROLL HANDLER -----------------
  const handleScroll = (e) => {
    if (isScrollAtBottom(e) && hasMore && !loading) {
      setParams((prev) => ({
        ...prev,
        page: prev.page + 1,
      }));
    }
  };

  // ----------------- SEARCH UPDATE -----------------
  useEffect(() => {
    setParams((prev) => ({
      ...prev,
      page: 1,
      search: globalSearch || undefined,
    }));
  }, [globalSearch]);

  // ----------------- INITIAL LOAD -----------------
  useEffect(() => {
    setParams((prev) => ({
      ...prev,
      page: 1,
    }));
  }, []);

  // ----------------- FETCH WHEN PARAMS CHANGE -----------------
  useEffect(() => {
    fetchAuctions(params.page === 1);
  }, [params]);

  return (
    <>
      <Main>
        <section className="auction-section-main">
          <div className="contant-select-headding">
            <div className="custome-headding-leftbar">
              <div className="orange-header">Auctions</div>
              <div className="game-modes-filter">
                {["All Auctions", "High Bids", "New Items", "Ending Soon"].map(
                  (mode) => (
                    <Button
                      key={mode}
                      type={activeMode === mode ? "primary" : "default"}
                      onClick={() => handleFilterChange(mode)}
                      className="mode-filter-btn"
                      loading={loading && activeMode === mode}
                    >
                      {mode}
                    </Button>
                  )
                )}
              </div>
            </div>
            <div className="auction-headding-rightbar">
              <Button
                className="fill-button-radius"
                onClick={() => navigate("/auctions-create")}
              >
                {" "}
                <Plus />
                Create Auction
              </Button>
            </div>
          </div>

          <div
            className="for-auction-main auction-main-list"
            onScroll={handleScroll}
          >
            {loading ? (
              <div style={{ textAlign: "center", padding: "50px" }}>
                <div>Loading auctions...</div>
              </div>
            ) : auctions.length === 0 ? (
              <div
                style={{ textAlign: "center", padding: "50px", color: "white" }}
              >
                <div>No auctions found</div>
              </div>
            ) : (
              auctions.map((auction, index) => (
                <div className="auction-inner-card" key={index}>
                  <img src={auction.images[0]} />
                  <div className="product-name">
                    <h4>{auction.itemName}</h4>
                    <p>{convertSecondToHours(auction.remainingTime)} left</p>
                  </div>
                  <div className="bid-price">
                    <img src={CoinImage} />
                    <h4>
                      Starting Bid :
                      <span className="red">{auction.startPrice} Tokens</span>
                    </h4>
                  </div>
                  <div className="bid-price">
                    <img src={CoinImage} />
                    <h4>
                      Current Bid :
                      <span className="green">
                        {auction.highestBidAmount} Tokens
                      </span>
                    </h4>
                  </div>
                  <Button
                    className="bid-button"
                    onClick={() =>
                      navigate(`/auctions/auctions-detail/${auction._id}`)
                    }
                  >
                    Bid Now
                  </Button>
                </div>
              ))
            )}
          </div>
        </section>
      </Main>
    </>
  );
};

export default AuctionsPage;
